<template>
  <div class="header" v-cloak>
    <div class="header_box">
      <div style="display: inline-block">
        <img
          src="../../Img/List/logo.png"
          @click.stop="toIndex"
          alt
          class="headerLogo"
        />
      </div>
      <div class="userName">
        <div class="homeBox" @click.stop="gohome">
          <svg-icon iconClass="homeIcon" class="homeIcon"></svg-icon>
          <span class="headerSize" v-if="index == 0" style="color:#ec9368"
            >首页</span
          >
          <span class="headerSize" v-else>首页</span>
        </div>
        <div class="spacer"></div>
        <div @click.stop="gotoshoppingCart" class="homeBox">
          <svg-icon iconClass="gouwuche" class="gouwuche"></svg-icon>
          <span class="headerSize" v-if="index == 1" style="color:#ec9368"
            >购物车</span
          >
          <span class="headerSize" v-else>购物车</span>
        </div>
        <div class="spacer"></div>
        <div @click.stop="gotoCommodityOrder" class="homeBox">
          <svg-icon iconClass="myOrder" class="myOrder"></svg-icon>
          <span class="headerSize" v-if="index == 2" style="color:#ec9368"
            >我的订单</span
          >
          <span class="headerSize" v-else>我的订单</span>
        </div>
        <div class="spacer"></div>
        <div style="position: relative;">
          <div @click.stop="setout" class="homeBox">
            <svg-icon iconClass="wode" class="wode"></svg-icon>
            <span class="headerSize">个人信息</span>
          </div>
          <div class="header_wode">
            <div
              class="user_zhanghu"
              v-if="userData.userCode"
              @click="upshowCondition"
            >
              {{ userData.userCode }}
            </div>
            <div class="user_Out" @click.stop="loginOut">退出</div>
          </div>
        </div>
        <div class="spacer"></div>
        <a
          href="https://static1.zlf.cn/pdf/order-1.pdf"
          target="_black"
          style="text-decoration:none;color: black;font-size:18px;display:flex"
        >
          <svg-icon iconClass="guide" class="guide"></svg-icon>
          <span class="headerSize">操作指引</span>
        </a>
        <div class="shadow" @click="upshowCondition"></div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  props: ["showImg", "index"],
  data() {
    return {
      userName: true,
      userData: {},
    };
  },
  mounted() {
    this.userData = JSON.parse(localStorage.getItem("userData"));
  },
  methods: {
    toIndex() {
      $(".shadow").css("display", "none");
      $(".header_wode").css("display", "none");
      this.$router.push({ path: "/home" });
    },
    // 前往购物车
    gotoshoppingCart() {
      $(".shadow").css("display", "none");
      $(".header_wode").css("display", "none");
      this.$router.push({ path: "/shoppingCart" });
      localStorage.setItem("title", "");
      localStorage.setItem("val", "");
    },
    // 前往订单页
    gotoCommodityOrder() {
      $(".shadow").css("display", "none");
      $(".header_wode").css("display", "none");
      this.$router.push({ path: "./CommodityOrder" });
      localStorage.setItem("title", "");
      localStorage.setItem("val", "");
    },
    // 前往首页
    gohome() {
      $(".shadow").css("display", "none");
      $(".header_wode").css("display", "none");
      this.$router.push({ path: "/home" });
      localStorage.setItem("title", "");
      localStorage.setItem("val", "");
    },
    // 退出登录
    loginOut() {
      var that = this;
      var url = "/direct/user/logout";
      document.body.style.overflow = "auto";
      that
        .$axios({
          url: url,
          method: "GET",
          cache: false,
          headers: {
            "T-token": JSON.parse(localStorage.getItem("userData")).token,
          },
        })
        .then((res) => {
          $(".shadow").css("display", "none");
          $(".header_wode").css("display", "none");
          this.$router.push({ path: "./" });
        });
    },
    setout() {
      $(".shadow").css("display", "block");
      $(".header_wode").css("display", "block");
      $(".header_wode").animate({ top: "28px" });
      document.body.style.overflow = "hidden";
    },
    // 关闭弹窗
    upshowCondition() {
      $(".header_wode").animate({ top: "-122px" });
      // $(".header_wode").css("display", "none");
      $(".shadow").css("display", "none");
      document.body.style.overflow = "auto";
      // this.userName = false
    },
    userNamedata() {
      this.userName = true;
    },
  },
};
</script>

<style scope>
[v-cloak] {
  display: none;
}
.user_Out {
  cursor: pointer;
  width: 100%;
  height: 42px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  font-size: 18px;
  color: #000;
  background-color: #fce6d9;
  text-align: center;
  line-height: 42px;
}
.user_Out:hover {
  background-color: #cdcdcd;
}
.user_zhanghu {
  width: 100%;
  height: 52px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  text-align: center;
  font-size: 18px;
  color: #ec9368;
  border-radius: 5px;
  background-color: #fff;
  line-height: 52px;
}
.box_header_wode {
  width: 274px;
  height: 94px;
}
.header_wode {
  width: 274px;
  height: 94px;
  /* position: relative; */
  position: absolute;
  z-index: 999;
  right: -93px;
  top: -122px;
  display: none;
  border-radius: 5px;
  background-color: #fff;
}
/* // 遮罩层 */
.shadow {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 990;
  background-color: #000;
  opacity: 0.6;
  display: none;
}
.header_box {
  display: flex;
  justify-content: space-between;
  width: 1200px;
  margin: 0 auto;
  align-items: center;
}
.wode {
  cursor: pointer;
  width: 22px;
  height: 22px;
}
.gouwuche {
  cursor: pointer;
  width: 22px;
  height: 22px;
  margin-right: 3px;
}
.myOrder {
  cursor: pointer;
  /* right: 1px; */
  width: 22px;
  height: 22px;
  margin-right: 3px;
}
.homeIcon {
  cursor: pointer;
  width: 22px;
  height: 22px;
  margin-right: 3px;
}
.guide {
  width: 24px;
  height: 24px;
}
.headerSize {
  cursor: pointer;
  font-size: 18px;
  color: #000;
}
.headerLogo {
  width: 128px;
  height: 59px;
  display: inline-block;
  /* margin-left: 360px; */
  padding-top: 10px;
  padding-bottom: 11px;
}
.city {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-top: 4px solid gray;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
}
.spacer {
  width: 2px;
  background: #ec9368;
  height: 18px;
  margin: 0 20px;
}
.userName {
  display: flex;
  font-size: 0;
  align-items: center;
}
.homeBox {
  display: flex;
  align-items: center;
}
.header {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 80px;
  background-image: url("../../Img/List/hera.png");
}
/* @media screen and (max-width: 1300px) {
    .header {
        width: 100%;
        height: 40px;
        background-color: blue; 
    }
} */
/* @media screen and (min-width: 1200px) {
    .header {
        width: 100%;
        height: 40px;
        background-color: black;
    }
}
@media screen and (min-width: 1400px) {
    .header {
        width: 100%;
        height: 40px;
        background-color: khaki;
    }
}
@media screen and (min-width: 1600px) {
    .header {
        width: 100%;
        height: 40px;
        background-color: green;
    }
}
@media screen and (min-width: 1920px) {
    .header {
        width: 100%;
        height: 40px;
        background-color: red;
    }
} */
</style>
